import { render } from "./customerRegisterMulti.vue?vue&type=template&id=06c2f188&scoped=true"
import script from "./customerRegisterMulti.vue?vue&type=script&lang=js"
export * from "./customerRegisterMulti.vue?vue&type=script&lang=js"

import "./customerRegisterMulti.vue?vue&type=style&index=0&id=06c2f188&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c2f188"]])

export default __exports__